// eslint-disable-next-line import/no-anonymous-default-export
export default {
  render: (formModel, attachNode) => {
    if (window.epi == null || window.epi.EPiServer == null || window.epi.EPiServer.Forms == null) {
      executeScript(formModel.assets.originalJquery);
      executeScript(formModel.assets.jquery);
    }

    executeScript(formModel.assets.prerequisite);
    injectStyles(formModel.assets.css);

    const element =
      typeof attachNode === 'object' ? attachNode : document.getElementById(attachNode);
    if (!element) {
      console.error('Target element not found for form rendering');
      return;
    }

    const container = document.createElement('div');
    container.innerHTML = formModel.template;

    const scripts = container.getElementsByTagName('script');
    Array.from(scripts).forEach((script) => {
      const newScript = document.createElement('script');

      Array.from(script.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      if (script.innerHTML) {
        newScript.innerHTML = script.innerHTML;
      }

      script.parentNode.replaceChild(newScript, script);
    });

    element.innerHTML = '';
    while (container.firstChild) {
      element.appendChild(container.firstChild);
    }

    if (window.epi && window.epi.EPiServer && window.epi.EPiServer.Forms) {
      window.epi.EPiServer.Forms.__Initialized = undefined;
    }
    executeScript(formModel.assets.viewModeJs);
  },
};

function executeScript(scriptContent) {
  if (!scriptContent) return;

  try {
    const script = document.createElement('script');
    script.text = scriptContent;
    document.head.appendChild(script);
    document.head.removeChild(script);
  } catch (error) {
    console.error('Error executing script:', error);
  }
}

function injectStyles(cssContent) {
  if (!cssContent) return;

  const style = document.createElement('style');
  style.type = 'text/css';
  style.textContent = cssContent;
  document.head.appendChild(style);
}
